import React from 'react';

const SliderExtremeMark = ({value, text, position, handleClick}) => (
    <div onClick={handleClick} onTouchEnd={handleClick}>
        <div>{value}</div>
        {text &&
            <div className={`extreme ${position}`}>
                <label>{text}</label>
            </div>
        }
    </div>
);

export default SliderExtremeMark;
